import script from "./ProfileSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileSettings.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileSettings.vue?vue&type=style&index=0&id=70b33876&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b33876"]])

export default __exports__